import { render, staticRenderFns } from "./staticInfoTreeDialog.vue?vue&type=template&id=bd97a2ac&scoped=true"
import script from "./staticInfoTreeDialog.vue?vue&type=script&lang=js"
export * from "./staticInfoTreeDialog.vue?vue&type=script&lang=js"
import style0 from "./staticInfoTreeDialog.vue?vue&type=style&index=0&id=bd97a2ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd97a2ac",
  null
  
)

export default component.exports